export function removeSpecialCharAndNumbers(inputStr) {
  const opStr = inputStr.replace(/[^a-zA-Z ]/g, "");
  return opStr;
}

export function removeSpecialCharacters(inputStr) {
  const opStr = inputStr.replace(/[^a-zA-Z0-9 ]/g, "");
  return opStr;
}

export function allowOnlyNumber(inputStr) {
  const opStr = inputStr.replace(/[^0-9]/g, "");
  return opStr;
}

export function allowRange(inputStr) {
  const opStr = inputStr.replace(/^\d+:\d+$|[A-Z]+:[A-Z]$/g, '');
  return opStr;
}

export function allowAllNumbers(inputStr) {
  const opStr = inputStr.replace(/[^0-9 . -]/g, "");
  return opStr;
}

/**
 * Filters out all non-digit characters from the input string, allowing only positive integers including 0.
 * @param inputStr - The input string to filter.
 * @returns A string containing only positive integers including 0.
 */
export function allowPositiveNumbers(inputStr) {
  const opStr = inputStr.replace(/[^0-9.]/g, "");
  // Handle multiple decimal points by keeping only the first one
  const parts = opStr.split('.');
  if (parts.length > 1) {
    return parts[0] + '.' + parts.slice(1).join('');
  }
  return opStr;
}

export function decimalPriceRegex(inputStr, maxDecimalPlaces = 2) {

  let opStr = inputStr.replace(/[^0-9.]/g, "");    // Remove everything except numbers and "."

  const firstDotIndex = opStr.indexOf(".");
  if (firstDotIndex !== -1) {
    opStr =
      opStr.slice(0, firstDotIndex + 1) + opStr.slice(firstDotIndex + 1).replace(/\./g, "");   // remove extra dots
  }

  const decimalPointIndex = opStr.indexOf(".");
  if (decimalPointIndex >= 0) {
    opStr = opStr.slice(0, decimalPointIndex + maxDecimalPlaces + 1);   // Limit to "maxDecimalPlaces" after the decimal
  }

  if (opStr === ".") {
    return "0.";          // If only "." is entered, convert to "0."
  }
  return opStr;
}

export function allowEverything(inputStr) {
  return inputStr;
}

export function passwordRegex(inputStr) {
  const opStr = allowOnlyNumber(inputStr).replace(/./g, "*");
  return opStr;
}

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const isValidPhoneNumber = (number) => {
  return /^[6-9]\d{9}$/.test(number);
};
